import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './guards/auth.guard';
import { AppLayoutComponent } from './layout-new/app.layout.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: 'home',
        loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'inscriptions',
        loadChildren: () => import('./modules/inscriptions/inscriptions.module').then((m) => m.InscriptionsModule),
      },
      {
        path: 'editions',
        loadChildren: () => import('./modules/editions/editions.module').then((m) => m.EditionsModule),
      },
      {
        path: 'messages',
        loadChildren: () => import('./modules/messages/messages.module').then((m) => m.MessagesModule),
      },
      {
        path: 'bookings',
        loadChildren: () => import('./modules/bookings/bookings.module').then((m) => m.BookingsModule),
      },
      {
        path: 'reservation-items',
        loadChildren: () =>
          import('./modules/reservation-items/reservation-items.module').then((m) => m.ReservationItemsModule),
      },
      {
        path: 'categories',
        loadChildren: () => import('./modules/settings/categories/categories.module').then((m) => m.CategoriesModule),
      },
      {
        path: 'scheduled-emails',
        loadChildren: () =>
          import('./modules/scheduled-emails/scheduled-emails.module').then((m) => m.ScheduledEmailsModule),
      },
      {
        path: 'sended-emails',
        loadChildren: () => import('./modules/sended-emails/sended-emails.module').then((m) => m.SendedEmailsModule),
      },
      {
        path: 'users',
        loadComponent: () => import('./modules/users/users.component').then((m) => m.UsersComponent),
      },
      {
        path: 'organization-users',
        loadComponent: () =>
          import('./modules/organization-users/organization-users.component').then((m) => m.OrganizationUsersComponent),
      },
      {
        path: 'galleries',
        loadComponent: () => import('./modules/galleries/galleries.component').then((m) => m.GalleriesComponent),
      },
      {
        path: 'forms',
        loadComponent: () =>
          import('./modules/forms/form-builder/form-builder.component').then((m) => m.FormBuilderComponent),
      },
      {
        path: 'submissions',
        loadComponent: () =>
          import('./modules/forms/submissions/submissions.component').then((m) => m.SubmissionsComponent),
      },
      {
        path: 'guides',
        loadChildren: () => import('./modules/guides/guides.module').then((m) => m.GuidesModule),
      },
      {
        path: 'community-forum',
        loadChildren: () =>
          import('./modules/community-forum/community-forum.module').then((m) => m.CommunityForumModule),
      },
      {
        path: 'ai-chat-prompts',
        loadChildren: () =>
          import('./modules/ai-chat-prompts/ai-chat-prompts.module').then((m) => m.AiChatPromptsModule),
      },
      {
        path: 'vehicles',
        loadChildren: () => import('./modules/vehicles/vehicles.module').then((m) => m.VehiclesModule),
      },
      {
        path: 'rooming-list',
        loadComponent: () =>
          import('./modules/organization-users/rooming-list/rooming-list.component').then(
            (m) => m.RoomingListComponent,
          ),
      },
      {
        path: 'map-waypoints',
        loadComponent: () =>
          import('./modules/map-waypoints/map-waypoints.component').then((m) => m.MapWaypointsComponent),
      },
      {
        path: 'legal-texts',
        loadComponent: () =>
          import('./modules/bookings/booking-legal-texts/booking-legal-texts.component').then(
            (m) => m.BookingLegalTextsComponent,
          ),
      },
      {
        path: 'booking-inscriptions',
        loadComponent: () =>
          import('./modules/bookings/booking-inscriptions/booking-inscriptions.component').then(
            (m) => m.BookingInscriptionsComponent,
          ),
      },
      {
        path: 'booking-team-access',
        loadComponent: () =>
          import('./modules/bookings/booking-team-access/booking-team-access.component').then(
            (m) => m.BookingTeamAccessComponent,
          ),
      },
      {
        path: 'booking-activity',
        loadComponent: () =>
          import('./modules/bookings/booking-activity/booking-activity.component').then(
            (m) => m.BookingActivityComponent,
          ),
      },
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
